import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function SaleTypeHomesite(
  this: ListingsService,
  listing: Listing,
  currentValue: boolean,
): boolean {
  // If no value is set, do not affect the filter.
  if (this.filteringService.includeHomesites()) {
    return currentValue;
  }

  // Determine if the listing matches the filter.
  if (listing.saleType === 'homesite') {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
